import type { PlanVehicleRulePayload } from '../types/planVehicleRule.types';

export const MAX_BATCH_RULES = 100;

export interface VehicleRuleSelections {
    makeIds: string[];
    transmissionIds: string[];
    fuelTypeIds: string[];
    modelId: string | null;
    derivativeId: string | null;
    engineMin: number | null;
    engineMax: number | null;
    ageMin: number | null;
    ageMax: number | null;
    requiresFourByFour?: boolean | null;
}

const orAny = (ids: string[]): (string | null)[] => (ids.length === 0 ? [null] : ids);

export function countVehicleRuleSelections(makes: number, transmissions: number, fuelTypes: number): number {
    return Math.max(makes, 1) * Math.max(transmissions, 1) * Math.max(fuelTypes, 1);
}

export function expandVehicleRuleSelections(input: VehicleRuleSelections): PlanVehicleRulePayload[] {
    const transmissions = input.derivativeId ? [null] : orAny(input.transmissionIds);
    const fuelTypes = input.derivativeId ? [null] : orAny(input.fuelTypeIds);

    return orAny(input.makeIds).flatMap((make_id) =>
        transmissions.flatMap((transmission_id) =>
            fuelTypes.map((fuel_type_id) => ({
                make_id,
                model_id: input.modelId,
                derivative_id: input.derivativeId,
                transmission_id,
                fuel_type_id,
                engine_min: input.engineMin,
                engine_max: input.engineMax,
                age_min: input.ageMin,
                age_max: input.ageMax,
                requires_4x4: input.requiresFourByFour ?? null,
            })),
        ),
    );
}
